<template>
  <v-lazy
    :min-height="$vuetify.breakpoint.smAndDown ? 130 : 196"
    transition="fade-transition"
  >
    <v-hover v-slot="data">
      <v-card
        v-if="product"
        :class="data.hover ? 'hover-zoom hover-zoom-active' : 'hover-zoom'"
        :disabled="productDisabled"
        :style="{filter: (productDisabled ? 'grayscale(1)' : 'grayscale(0)')}"
        color="brand-card-bg"
        flat
        @click.stop="onProductClick"
      >
        <v-list
          class="pa-0"
          color="brand-card-bg"
          dense
          three-line
        >
          <v-list-item :class="$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-6'">
            <v-list-item-content class="align-content-space-between justify-start pa-1">
              <div class="align-center overflow-hidden">
                <v-list-item-title class="brand-green-dark--text text-body">
                  <span
                    v-safe-html="productName"
                    class="text-body"
                  />
                </v-list-item-title>

                <v-list-item-subtitle
                  v-safe-html="productDescription"
                  class="mt-1 brand-text-small brand-grey--text text-overflow-3"
                />
              </div>

              <div class="d-flex align-center">
                <product-price
                  :disabled="productDisabled"
                  :product="product.DetailsData"
                />

                <v-spacer />

                <product-tags
                  :style="product.Image ? '' : 'position:absolute; bottom: 24px; right: 24px; z-index: 3;'"
                  :tags="product.Tags"
                  icon-only
                  small
                />
              </div>
            </v-list-item-content>

            <div
              :style="$vuetify.breakpoint.smAndDown ? 'max-width: 115px;' : 'max-width: 170px;'"
              class="pa-1 overflow-visible"
            >
              <v-img
                :height="$vuetify.breakpoint.smAndDown ? 77 : 116"
                :src="product.Image"
                :style="{filter: (productDisabled ? 'grayscale(1)' : 'grayscale(0)')}"
                class="rounded rounded-tr-0"
              />
            </div>

            <div
              v-if="storeCanSellItemsById(product.StoreId) || (!AppConfig.StoreClosed.DisableAddToCart && storeCanSellItemsById(product.StoreId))"
              :style="$vuetify.breakpoint.smAndDown ? 'position: absolute; top: 4px; right: 4px;' : 'position: absolute; top: 8px; right: 8px;'"
            >
              <v-btn
                v-if="!productDisabled"
                :height="$vuetify.breakpoint.smAndDown ? 36 : 45"
                :loading="product.Loading"
                :width="$vuetify.breakpoint.smAndDown ? 36 : 45"
                color="brand-green-dark"
                depressed
                icon
                outlined
                style="background-color: #FFFFFF;"
                @click.stop="onProductQuickAddClick"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </v-hover>
  </v-lazy>
</template>

<script>

import CatalogProductListItemMixin from '@/theme/default/components/store/CatalogProductListItem.js'

export default {
  name  : 'CatalogProductListItem',
  mixins: [CatalogProductListItemMixin]
}
</script>

<style scoped src="@/theme/default/components/store/CatalogProductListItem.css"></style>

<style scoped>
</style>
